import { socialNames } from '@elab/core/utils/constants';

export const socialRegistrationUri = social => {
    switch (social) {
        case socialNames.APPLE:
            return 'social/actions/apple';
        case socialNames.TWITTER:
            return 'social/actions/twitter';
        case socialNames.FACEBOOK:
            return 'social/actions/facebook';
        case socialNames.GOOGLE:
            return 'social/actions/google';
        default:
            break;
    }
};
